import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './coletaForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { sortData } from '../common/table/sortHelper';
import Select from '../common/form/select';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista,
    getOpcoes,
    getAreasCliente
} from './coletaActions';

const columns = [
    { field: 'numero', type: 'number' },
    { field: 'datahora_solicitacao', type: 'date' },
    { field: 'data_previsao_coleta', type: 'date' },
    { field: 'nome_cliente', type: 'text' },
    { field: 'status', type: 'text' },
    { field: 'quantidade_areas', type: 'number' },
    { field: 'valor_liquido', type: 'number' }
];

const formatarMoeda = valor =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;

const STATUS_LABELS = {
    AGUARDANDO_APROVACAO: 'Aguardando aprovação',
    REJEITADO: 'Rejeitada',
    APROVADO_AGUARDANDO_COLETA: 'Aguardando coleta',
    COLETADO: 'Coletada',
    ENVIADO_LABORATORIO: 'No laboratório',
    FINALIZADA: 'Finalizada'
};

const dataHoraAtualInput = () => {
    const data = new Date();

    data.setMinutes(
        data.getMinutes() - data.getTimezoneOffset()
    );

    return data.toISOString().substring(0, 16);
};

const dataAtualInput = () => {
    const data = new Date();

    data.setMinutes(
        data.getMinutes() - data.getTimezoneOffset()
    );

    return data.toISOString().substring(0, 10);
};

const dataLocal = valor => {
    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
        return '';
    }

    data.setMinutes(
        data.getMinutes() - data.getTimezoneOffset()
    );

    return data.toISOString().substring(0, 10);
};

const formatarDataInput = valor => {
    const data = new Date(valor);

    data.setMinutes(
        data.getMinutes() - data.getTimezoneOffset()
    );

    return data.toISOString().substring(0, 10);
};

const criarPeriodoPadrao = () => {
    const dataFinal = new Date();
    const dataInicial = new Date();

    dataInicial.setDate(dataInicial.getDate() - 31);

    return {
        dataInicial: formatarDataInput(dataInicial),
        dataFinal: formatarDataInput(dataFinal)
    };
};

const FiltrosColeta = props => (
    <div
        style={{
            marginTop: 8,
            padding: '12px 12px 2px',
            borderRadius: 10,
            background: '#f3f7fb',
            border: '1px solid #dce3eb'
        }}
    >
        <Row>
            <Grid cols='12 6 3 2'>
                <div className='form-group'>
                    <label>Data inicial</label>
                    <input
                        type='date'
                        className='form-control'
                        value={props.dataInicial}
                        onChange={event =>
                            props.onDataInicial(
                                event.target.value
                            )}
                    />
                </div>
            </Grid>
            <Grid cols='12 6 3 2'>
                <div className='form-group'>
                    <label>Data final</label>
                    <input
                        type='date'
                        className='form-control'
                        value={props.dataFinal}
                        onChange={event =>
                            props.onDataFinal(
                                event.target.value
                            )}
                    />
                </div>
            </Grid>
            <Select
                name='filtro_clientes_coleta'
                options={props.clientes}
                label='Cliente'
                cols='12 12 6 3'
                multiple
                value={props.idsClientes}
                onChange={itens =>
                    props.onClientes(
                        (itens || []).map(item =>
                            Number(item.value)
                        )
                    )}
            />
            <Select
                name='filtro_status_coleta'
                options={props.status}
                label='Status'
                cols='12 12 6 3'
                multiple
                value={props.idsStatus}
                onChange={itens =>
                    props.onStatus(
                        (itens || []).map(item =>
                            Number(item.value)
                        )
                    )}
            />
            <Grid cols='12 6 3 2'>
                <button
                    type='button'
                    className='btn btn-light'
                    onClick={props.onLimpar}
                    style={{
                        width: '100%',
                        minHeight: 38,
                        marginTop: 29,
                        border: '1px solid #cbd5e1',
                        borderRadius: 8
                    }}
                >
                    <i
                        className='fas fa-eraser'
                        style={{ marginRight: 7 }}
                    />
                    Limpar filtros
                </button>
            </Grid>
        </Row>
    </div>
);

const Coleta = props => {

    const [linhaSelecionada, setLinhaSelecionada] =
        useState(null);

    const [pesquisar, setPesquisar] = useState('');
    const [filtros, setFiltros] = useState({
        ...criarPeriodoPadrao(),
        idsClientes: [],
        idsStatus: []
    });

    const [sort, setSort] = useState({
        field: 'numero',
        direction: 'desc'
    });

    useEffect(() => {
        props.getLista();
        props.getOpcoes();
    }, []);

    const onSort = field => {
        setSort(anterior => ({
            field,
            direction:
                anterior.field === field &&
                anterior.direction === 'asc'
                    ? 'desc'
                    : 'asc'
        }));
    };

    const filtrar = () => {
        const termoPesquisa = (pesquisar || '')
            .trim()
            .toUpperCase();

        const listaFiltrada = (props.lista || [])
            .filter(item => {
                const dataItem = dataLocal(
                    item.datahora_solicitacao
                );

                if (
                    filtros.dataInicial &&
                    dataItem < filtros.dataInicial
                ) {
                    return false;
                }

                if (
                    filtros.dataFinal &&
                    dataItem > filtros.dataFinal
                ) {
                    return false;
                }

                if (
                    filtros.idsClientes.length &&
                    !filtros.idsClientes.includes(
                        Number(item.id_cliente)
                    )
                ) {
                    return false;
                }

                if (
                    filtros.idsStatus.length &&
                    !filtros.idsStatus.includes(
                        Number(item.id_status)
                    )
                ) {
                    return false;
                }

                if (!termoPesquisa) {
                    return true;
                }

                const texto = `
                    ${item.numero || ''}
                    ${item.nome_cliente || ''}
                    ${item.nome_status ||
                        STATUS_LABELS[item.status] ||
                        item.status ||
                        ''}
                    ${item.observacao || ''}
                    ${item.quantidade_areas || ''}
                    ${formatarMoeda(item.valor_liquido)}
                `.toUpperCase();

                return termoPesquisa
                    .split('+')
                    .filter(parte => parte.trim())
                    .every(parte =>
                        texto.includes(parte.trim())
                    );
            });

        return sortData(
            listaFiltrada,
            sort,
            columns
        );
    };

    const montarExcel = lista => {
        const ExcelSheet =
            ReactExport.ExcelFile.ExcelSheet;

        const ExcelColumn =
            ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista.map(item => ({
                    ...item,
                    data_solicitacao_formatada:
                        getDataHoraFormatada(
                            item.datahora_solicitacao,
                            'DD/MM/YYYY HH:mm'
                        ),
                    previsao_formatada:
                        getDataHoraFormatada(
                            item.data_previsao_coleta,
                            'DD/MM/YYYY'
                        ),
                    valor_total_formatado:
                        formatarMoeda(item.valor_total),
                    desconto_formatado:
                        formatarMoeda(item.valor_desconto),
                    valor_liquido_formatado:
                        formatarMoeda(item.valor_liquido),
                    status_formatado:
                        item.nome_status ||
                        STATUS_LABELS[item.status] ||
                        item.status,
                    pagamento_formatado: `${
                        item.nome_forma_pagamento ||
                        item.forma_pagamento ||
                        ''
                    } - ${item.quantidade_parcelas || 1} ${
                        Number(item.quantidade_parcelas || 1) === 1
                            ? 'vez'
                            : 'vezes'
                    }`
                }))}
                name='Coletas'
            >
                <ExcelColumn label='Número' value='numero' />
                <ExcelColumn
                    label='Data da Solicitação'
                    value='data_solicitacao_formatada'
                />
                <ExcelColumn
                    label='Previsão da Coleta'
                    value='previsao_formatada'
                />
                <ExcelColumn
                    label='Cliente'
                    value='nome_cliente'
                />
                <ExcelColumn
                    label='Status'
                    value='status_formatado'
                />
                <ExcelColumn
                    label='Responsáveis pela Coleta'
                    value='nomes_usuarios_coleta'
                />
                <ExcelColumn
                    label='Pagamento'
                    value='pagamento_formatado'
                />
                <ExcelColumn
                    label='Quantidade de Áreas'
                    value='quantidade_areas'
                />
                <ExcelColumn
                    label='Quantidade de Amostras'
                    value='quantidade_amostras'
                />
                <ExcelColumn
                    label='Valor Total'
                    value='valor_total_formatado'
                />
                <ExcelColumn
                    label='Desconto'
                    value='desconto_formatado'
                />
                <ExcelColumn
                    label='Valor Final'
                    value='valor_liquido_formatado'
                />
                <ExcelColumn
                    label='Observação'
                    value='observacao'
                />
            </ExcelSheet>
        );
    };

    const abrirRegistro = (modo, item) => {
        props.setModoTela(modo, {
            ...item
        });

        props.initForm({
            ...item,
            areas: item.areas || []
        });

        props.getAreasCliente(item.id_cliente);
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();
        const formaPagamentoPadrao = (
            props.formasPagamento || []
        ).find(item => item.codigo === 'A_VISTA');

        const alturaTabela = Math.max(
            250,
            window.innerWidth < 631
                ? window.innerHeight - 430
                : window.innerHeight - 320
        );

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={value =>
                                setPesquisar(value)
                            }
                        />

                        <div>
                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{
                                    marginLeft: 2,
                                    minWidth: 75
                                }}
                                onClick={() => {
                                    props.setModoTela(
                                        'cadastro',
                                        {}
                                    );

                                    props.initForm({
                                        datahora_solicitacao:
                                            dataHoraAtualInput(),
                                        data_previsao_coleta:
                                            dataAtualInput(),
                                        id_cliente: null,
                                        id_veiculo: null,
                                        status:
                                            'AGUARDANDO_APROVACAO',
                                        id_forma_pagamento:
                                            formaPagamentoPadrao
                                                ? formaPagamentoPadrao.id
                                                : null,
                                        quantidade_parcelas: 1,
                                        id_plano_conta_receita: 3,
                                        data_primeiro_vencimento:
                                            dataAtualInput(),
                                        observacao: '',
                                        areas: []
                                    });

                                    props.getAreasCliente(null);
                                }}
                            >
                                <i className='fas fa-plus' />
                                Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{
                                    marginLeft: 2,
                                    minWidth: 75
                                }}
                                onClick={() => {
                                    props.getLista();
                                    props.getOpcoes();
                                }}
                            >
                                <i className='fas fa-sync-alt' />
                                Atualizar
                            </button>

                            <ExcelFile
                                filename='Coletas'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{
                                            marginLeft: 2,
                                            minWidth: 75
                                        }}
                                    >
                                        <i className='fas fa-file-excel' />
                                        Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                    <FiltrosColeta
                        dataInicial={filtros.dataInicial}
                        dataFinal={filtros.dataFinal}
                        idsClientes={filtros.idsClientes}
                        idsStatus={filtros.idsStatus}
                        clientes={props.clientes}
                        status={props.status}
                        onDataInicial={valor =>
                            setFiltros({
                                ...filtros,
                                dataInicial: valor
                            })}
                        onDataFinal={valor =>
                            setFiltros({
                                ...filtros,
                                dataFinal: valor
                            })}
                        onClientes={valores =>
                            setFiltros({
                                ...filtros,
                                idsClientes: valores
                            })}
                        onStatus={valores =>
                            setFiltros({
                                ...filtros,
                                idsStatus: valores
                            })}
                        onLimpar={() => setFiltros({
                            ...criarPeriodoPadrao(),
                            idsClientes: [],
                            idsStatus: []
                        })}
                    />
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='numero'
                                    label='Número'
                                    width={90}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='datahora_solicitacao'
                                    label='Data da Solicitação'
                                    width={150}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='data_previsao_coleta'
                                    label='Previsão'
                                    width={120}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='nome_cliente'
                                    label='Cliente'
                                    width={260}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='status'
                                    label='Status'
                                    width={170}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='quantidade_areas'
                                    label='Áreas'
                                    width={80}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='valor_liquido'
                                    label='Valor Final'
                                    width={130}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <Th sticky alignCenter width={50} />
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, index) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : index % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.numero}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {getDataHoraFormatada(
                                            item.datahora_solicitacao,
                                            'DD/MM/YYYY HH:mm'
                                        )}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {getDataHoraFormatada(
                                            item.data_previsao_coleta,
                                            'DD/MM/YYYY'
                                        )}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.nome_cliente}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.nome_status ||
                                            STATUS_LABELS[item.status] ||
                                            item.status}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.quantidade_areas}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {formatarMoeda(
                                            item.valor_liquido
                                        )}
                                    </Td>

                                    <Td
                                        alignCenter
                                        minWidth={130}
                                        maxWidth={130}
                                    >
                                        <ButtonTable
                                            type='info'
                                            width={32}
                                            small
                                            icon='fas fa-eye'
                                            visible
                                            title='Abrir coleta'
                                            event={() =>
                                                abrirRegistro(
                                                    'cadastro',
                                                    item
                                                )
                                            }
                                        />

                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible={
                                                item.status ===
                                                'AGUARDANDO_APROVACAO'
                                            }
                                            title='Excluir'
                                            event={() =>
                                                abrirRegistro(
                                                    'exclusao',
                                                    item
                                                )
                                            }
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}

            {props.modoTela === 'exclusao' &&
                <Form excluir onSubmit={props.excluir} />}

            {props.modoTela === 'lista' &&
                renderLista()}
        </Content>
    );
};

const mapStateToProps = state => ({
    modoTela: state.coleta.modoTela,
    aguardando: state.coleta.aguardando,
    lista: state.coleta.lista,
    formasPagamento: state.coleta.formasPagamento,
    clientes: state.coleta.clientes.map(item => ({
        ...item,
        valor: item.razao_social
    })),
    status: state.coleta.status.map(item => ({
        ...item,
        valor: item.descricao
    }))
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela,
        initForm,
        salvar,
        excluir,
        getLista,
        getOpcoes,
        getAreasCliente
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Coleta);
